import React from 'react';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import { FreeBetsStatus } from '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../_tslib-7a01aab4.js';
import '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';

var FreeBetInfo = function (_a) {
    var t = _a.t, infoData = _a.infoData, selectFreeBet = _a.selectFreeBet, selectedFreeBetId = _a.selectedFreeBetId;
    return (React.createElement("div", { className: 'info-wrap' },
        React.createElement("div", { className: 'info' },
            React.createElement("div", { className: 'info-top' },
                React.createElement("p", { className: 'free-bet-info-status' }, infoData.status === FreeBetsStatus.Expired
                    ? t(TranslationKeys.Expired)
                    : infoData.remainingCount &&
                        (infoData.status === FreeBetsStatus.Accepted || infoData.status === FreeBetsStatus.Pending)
                        ? t(TranslationKeys.InProcess)
                        : t(TranslationKeys.Finished)),
                React.createElement("div", { className: 'free-bet-info-content' },
                    React.createElement("div", { className: 'free-bet-info-content-row' },
                        infoData.maxPayout && (React.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.MaxPayout)),
                            ":",
                            React.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.maxPayout))),
                        React.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.TotalWinByNow)),
                            ":",
                            React.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.totalWin)),
                        React.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.ReceiveDate)),
                            ":",
                            React.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.receiveDate)),
                        React.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.ExpirationDate)),
                            ":",
                            React.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.expireDateFreeBet))))),
            React.createElement("div", { className: 'info-bottom' },
                React.createElement("div", { className: 'free-bet-info-wr-bottom-inner' },
                    React.createElement("p", { className: 'free-bet-info-wr-bottom-inner-txt' },
                        infoData.count - infoData.remainingCount,
                        "/",
                        infoData.count)),
                React.createElement("div", { className: 'free-bet-info-wr-bottom-inner' }, infoData.status !== FreeBetsStatus.Finished &&
                    infoData.status !== FreeBetsStatus.Expired &&
                    !!infoData.remainingCount && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: 'free-bet-info-wr-bottom-inner-txt' }, t(TranslationKeys.FreeBet)),
                    React.createElement("div", { className: 'free-bet-info-wr-switch' },
                        React.createElement("label", { className: 'switch' },
                            React.createElement("input", { type: 'checkbox', checked: selectedFreeBetId === infoData.id, onChange: function () { return selectFreeBet(infoData); } }),
                            React.createElement("span", { className: 'slider round' }))))))))));
};

export { FreeBetInfo };
